//
//
//
//
//
//
//
//

export default {
  methods: {
    getBreadcrumbs (pageBlok) {
      return [
        { title: this.$t('legalHub.legalHub'), url: this.$url.articlesIndex() },
        { title: pageBlok.title },
      ]
    }
  },
}
